export const welcome: string = `Hey There!! Welcome to my space on the Internet!`;
export const about: string = `I'm Naren, I umm......do stuff. In my free time, I conduct amateur 
research about the chaos theory and explore cellular automaton and build things (interactive interfaces and web servers). Well apart from this, I work at a smoll startup building cool things!`;
export const more: string = `If you're looking for code, you can check out my GitHub profile here ---->`
